module.exports = __webpack_public_path__ + "static/media/most_simple.35029ed4.svg";